/**
 * @documental
 * @export Group
 * @name
 * Menu.Group
 */

import { FC, ReactNode } from "react";

/**
 * The `Group` component properties.
 */
export interface GroupProps {
  /**
   * The group label.
   */
  readonly label?: ReactNode;

  /**
   * The group children.
   */
  readonly children?: ReactNode;
}

/**
 * Groups a series of options.
 */
export const Group: FC<GroupProps> = () => {
  return null;
};
